import React from 'react';

// Components
import ToolbarTool from '../../../ToolbarTool';
import Icon from '../../../../../../components/icons/Icon';
import {
    useLegacyActiveTableCallback,
    useLegacyActiveTableSelector,
} from '../../../../../../element/table/store/legacyHotTableStoreHooks';

// Utils
import { getNewTransactionId } from '../../../../../../utils/undoRedo/undoRedoTransactionManager';
import { isSelectingMultipleSelections } from '../../../../../../element/table/legacy/utils/tableCellSelectionUtils';
import { addHotTableColsRight } from '../../../../../../element/table/legacy/utils/hotInstanceUtils/hotTableGridOperationsUtils';

// Selectors
import { selectLegacyActiveTableCellSelection } from '../../../../../../element/table/store/selectors/legacyActiveHotTableSelectors';

const LegacyAddColumnTool: React.FC = (props) => {
    const currentCellSelections = useLegacyActiveTableSelector(selectLegacyActiveTableCellSelection);

    const onClick = useLegacyActiveTableCallback(
        (activeTable) => addHotTableColsRight(activeTable, undefined, getNewTransactionId()),
        [],
    );

    return (
        <div className="AddColumnTool LegacyAddColumnTool">
            <ToolbarTool
                {...props}
                onClick={onClick}
                isActive={false}
                disabled={isSelectingMultipleSelections(currentCellSelections)}
                tooltipEnabled={true}
                shortcut={['alt', '→']}
            >
                <Icon name="toolbar-add-column" />
            </ToolbarTool>
        </div>
    );
};

export default LegacyAddColumnTool;
